import { COUNTRY_CODE } from '../constants';

export const isColombia = () => process.env.NEXT_PUBLIC_COUNTRY_CODE === COUNTRY_CODE.COLOMBIA;

export const getCountryName = () => {
  switch (process.env.NEXT_PUBLIC_COUNTRY_CODE) {
    case COUNTRY_CODE.COLOMBIA:
      return 'Colombia';
    case COUNTRY_CODE.MEXICO:
      return 'México';
  }
};

type Props = {
  countries: string[];
  children?: any;
};

export const RenderOnlyInCountries = ({ countries, children }: Props) => {
  const currentCountry = process.env.NEXT_PUBLIC_COUNTRY_CODE;
  return typeof currentCountry === 'string' && countries.includes(currentCountry) ? children : null;
};
